export default "__VITE_ASSET__Y4_C$Ox2__"